import React from 'react'
import PropTypes from 'prop-types'
import { TagTextBox, TagContainer, Line } from './TagHeaderStyledComponents'

const TagHeader = React.memo(({ name }) => (
  <TagContainer initialPose='hidden' pose='visible'>
    <Line />
    <TagTextBox>{name}</TagTextBox>
  </TagContainer>
))

TagHeader.displayName = 'TagHeader'

TagHeader.propTypes = {
  name: PropTypes.string.isRequired
}

export default TagHeader
